import { Layout } from "../layout";
import { WegetTable } from "./wegets/weget-table";
import styled from 'styled-components';
import { WegetEventButtons } from "./wegets/weget-event-buttons";
import { FetcherComponent } from "./fetcher/FetcherComponent";

const StyledContainer = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    display: flex;
    flex-direction: column;
`;

export function MainView(props) {
    return (
        <>
            <FetcherComponent />
            <Layout>
                <StyledContainer>
                    <WegetTable />
                    <WegetEventButtons />
                </StyledContainer>
            </Layout>
        </>
    );
}